import {ActionEnum} from "../action.enum";
import {
  AssessmentWithSeverityActionReference
} from "../../enums/assessment_with_severity_action/assessment-with-severity-action-source.enum";
import {
  AssessmentWithSeverityAction
} from "../../models/assessment-with-severity-action/assessment-with-severity-action.model";

export namespace AssessmentWithSeverityActionDialogAction {

  export class Init {
    static readonly type: ActionEnum = ActionEnum.ASSESSMENT_WITH_SEVERITY_ACTION_DIALOG_INIT;

    constructor(public reference: AssessmentWithSeverityActionReference, public referenceId: string) {}
  }

  export class UpdateAssessment {
    static readonly type: ActionEnum = ActionEnum.ASSESSMENT_WITH_SEVERITY_ACTION_DIALOG_UPDATE_SEVERITY_ACTION;

    constructor(public overallAssessmentId: string, public updatedValue: AssessmentWithSeverityAction) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.ASSESSMENT_WITH_SEVERITY_ACTION_DIALOG_SAVE;
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.ASSESSMENT_WITH_SEVERITY_ACTION_DIALOG_DELETE;
  }

  export class Reset {
    static readonly type: ActionEnum = ActionEnum.ASSESSMENT_WITH_SEVERITY_ACTION_DIALOG_RESET;
  }

}
